import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { convertToSentenceCase } from '../../../../../shared/utils/convert-to-sentence-case/convert-to-sentence-case.util';
import { useAppDispatch } from '../../../../../store/hooks';
import { ItemLabelModel } from '../../../../shared/components/dropdown/models/dropdown-props.model';
import { StatesEnum } from '../../../../shared/enums/states.enum';
import { mapStatesEnumToItemLabelModel } from '../../../../shared/utils/mapping/mapping.utils';
import { optionEquality } from '../../../../shared/utils/option-equality/option-equality.util';
import { filterAppsByStatus } from '../../../store/slices/apps.slice';
import { AppsFilterProps } from '../types/apps-filter-props.type';
import { withAppsFilterValues } from './with-apps-filter-values';

const StatusDropdown: FunctionComponent<AppsFilterProps> = (
  props: PropsWithChildren<AppsFilterProps>
) => {
  const {
    setFieldValue,
    errors,
    touched,
    selectedAppFilters: { status },
  } = props;
  const dispatch = useAppDispatch();
  const options = [StatesEnum.PENDING, StatesEnum.RELEASED, StatesEnum.SAVED];

  return (
    <FormControl
      key="apps-status"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="status"
        getOptionLabel={o => convertToSentenceCase(o.label)}
        isOptionEqualToValue={optionEquality}
        onChange={(event, value) => {
          const val = value as ItemLabelModel;
          setFieldValue('status', val);
          dispatch(filterAppsByStatus(val?.label));
        }}
        value={
          status
            ? options
                .map(mapStatesEnumToItemLabelModel)
                .find(x => x.label === status)
            : null
        }
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="status"
            label="Status"
            name="status"
            errors={errors}
            touched={touched}
          />
        )}
        options={options.map(mapStatesEnumToItemLabelModel)}
      />
    </FormControl>
  );
};

export default withAppsFilterValues(StatusDropdown);
